import { css } from '@emotion/react';
import { useState } from 'react';

import { theme } from '../theme';

import { SUMMARY_TITLE } from './constants';
import { CartSummary } from './internal/CartSummary';
import { PriceField } from './PriceField';
import { LegacyPriceItem } from './types';

const container = css`
  margin: 0 ${theme.spacing.md} 0 0;
  border-radius: ${theme.borders.radius.md};
  display: flex;
  flex-direction: column;
  @media (max-width: ${theme.breakpoints.laptop}) {
    margin-right: 0;
  }
`;

type Props = {
  priceItems: LegacyPriceItem[];
  pointOfSale: string;
  shouldDisplayPrice: boolean;
  isSarRebooking?: boolean;
};

export function CartPriceList({ priceItems, pointOfSale, isSarRebooking = false, shouldDisplayPrice }: Props) {
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const handleExpandedPaxClick = (id: number) =>
    setSelectedId((previousId: number | null) => (previousId === id ? null : id));

  const summaryItem = priceItems.find(item => item.title === SUMMARY_TITLE);
  const priceFields = priceItems.filter(item => item.title !== SUMMARY_TITLE);

  return (
    <>
      {priceFields && priceFields.length > 1 ? (
        <div css={container}>
          {priceFields
            .filter(priceItem => priceItem.id <= 5)
            .map(priceItem => (
              <PriceField
                isSarRebooking={isSarRebooking}
                key={priceItem.id}
                priceItem={priceItem}
                selectedId={selectedId}
                pointOfSale={pointOfSale}
                shouldDisplayPrice={shouldDisplayPrice}
                handleExpandedPaxClick={handleExpandedPaxClick}
              />
            ))}
        </div>
      ) : null}

      <div>
        {priceFields
          .filter(priceItem => priceItem.id > 5)
          .map(priceItem => (
            <PriceField
              isSarRebooking={isSarRebooking}
              key={priceItem.id}
              priceItem={priceItem}
              selectedId={selectedId}
              pointOfSale={pointOfSale}
              shouldDisplayPrice={shouldDisplayPrice}
              handleExpandedPaxClick={handleExpandedPaxClick}
            />
          ))}
        {summaryItem && (
          <CartSummary
            summaryItem={summaryItem}
            pointOfSale={pointOfSale}
            shouldDisplayPrice={shouldDisplayPrice}
            isSarRebooking={isSarRebooking}
          />
        )}
      </div>
    </>
  );
}
